import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _CircularProgress;
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import filesize from 'filesize';
import _ from 'lodash';
import moment from 'moment';
import React, { useContext } from 'react';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import CircularProgress from '@mui/material/CircularProgress';
import fileStyles from '../../file-icons.css'; // eslint-disable-line css-modules/no-unused-class
import SkholeIcon13 from '../../statelessComponents/Icons/SkholeIcon13';
import ContextProvider from '../../../context';
import s from './Attachment.scss';
import messages from './messages';
import intlPropTypes from '../../../constants/intlPropTypes';
var Attachment = function Attachment(_ref) {
  var _cx;
  var item = _ref.item,
    _ref$displayConcisely = _ref.displayConcisely,
    displayConcisely = _ref$displayConcisely === void 0 ? false : _ref$displayConcisely,
    total = _ref.total,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    formatMessage = _ref.intl.formatMessage,
    _ref$uploadingAttachm = _ref.uploadingAttachment,
    uploadingAttachment = _ref$uploadingAttachm === void 0 ? 0 : _ref$uploadingAttachm,
    _ref$showConfirmDelet = _ref.showConfirmDelete,
    showConfirmDelete = _ref$showConfirmDelet === void 0 ? function () {
      return null;
    } : _ref$showConfirmDelet,
    _ref$withSocketServer = _ref.withSocketServerValidation,
    withSocketServerValidation = _ref$withSocketServer === void 0 ? false : _ref$withSocketServer,
    _ref$socketServerVali = _ref.socketServerValidationResult,
    socketServerValidationResult = _ref$socketServerVali === void 0 ? null : _ref$socketServerVali;
  var _useContext = useContext(ContextProvider),
    cloudfrontUrl = _useContext.cloudfrontUrl;
  return /*#__PURE__*/_jsx("div", {
    className: cx(s.item, (_cx = {}, _defineProperty(_cx, s.concisely, displayConcisely), _defineProperty(_cx, s.items2, displayConcisely && total <= 2), _defineProperty(_cx, s.items1, displayConcisely && total === 1), _cx))
  }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("div", {
    className: cx(fileStyles.file, fileStyles[item.type])
  })), /*#__PURE__*/_jsx("div", {
    className: s.info
  }, void 0, /*#__PURE__*/_jsx(Button, {
    component: "a",
    href: "".concat(cloudfrontUrl, "/").concat(item.path),
    target: "_blank",
    className: cx(s.button, s.fileNameBtn)
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    className: s.fileName
  }, void 0, item.name)), /*#__PURE__*/_jsx("div", {
    className: s.details
  }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "body1",
    className: s.attrTitle
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.type)), ' ', _.toUpper(item.type)), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "body1",
    className: s.attrTitle
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.size)), ' ', filesize(item.size)), !displayConcisely || total === 1 && /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "body1",
    className: s.attrTitle
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.uploaded)), ' ', moment(item.uploadedDate).format('DD/MM/YYYY HH:mm')))), !displayConcisely && !readOnly && /*#__PURE__*/_jsx("div", {
    className: s.btn
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    title: formatMessage(messages.deleteAttachmentTitle)
  }, void 0, /*#__PURE__*/_jsx(IconButton, {
    onClick: showConfirmDelete,
    className: cx(s.button, s.notDisplayOnMobile),
    disabled: !!uploadingAttachment || readOnly || withSocketServerValidation && !socketServerValidationResult
  }, void 0, /*#__PURE__*/_jsx(SkholeIcon13, {
    className: s.removeIcon
  }))), /*#__PURE__*/_jsx(Button, {
    onClick: showConfirmDelete,
    className: cx(s.button, s.notDisplayOnTabletAndDesktop),
    disabled: !!uploadingAttachment || readOnly || withSocketServerValidation && !socketServerValidationResult,
    fullWidth: true,
    variant: "outlined",
    size: "large",
    color: "primary"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: s.removeIcon
  }), "\xA0", /*#__PURE__*/React.createElement(FormattedMessage, messages.deleteAttachmentTitle))), withSocketServerValidation && /*#__PURE__*/_jsx("div", {}, void 0, !socketServerValidationResult && /*#__PURE__*/_jsx("div", {
    className: s.validatingBlock
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.socketServerValidating), _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {
    size: 20
  }))), !!socketServerValidationResult && !(socketServerValidationResult !== null && socketServerValidationResult !== void 0 && socketServerValidationResult.isValid) && /*#__PURE__*/_jsx(Typography, {
    color: "error"
  }, void 0, socketServerValidationResult.error)));
};
export default compose(injectIntl, withStyles(s), withStyles(fileStyles))(Attachment);